module.exports = __webpack_public_path__ + "img/17.2cf1b55b.jpg";